<template>
  <vue-recaptcha ref="captcha"
                 sitekey="6LdwwFUUAAAAAPxTLzdEwcE-wEfkE5fCYNP98DLH"
                 @verify="token => $emit('verify', token)" />
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  components: {
    VueRecaptcha,
  },
  methods: {
    reset() {
      this.$refs.captcha.reset();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Captcha.vue